<div
  class="basin-display-flex basin-flex-row canvas-area basin-height-100 basin-width-100"
>
  <div class="column" [style.width]="visibleSidebar ? width : '0rem'">
    <app-accordion-column></app-accordion-column>
    <button class="column-toggle" (click)="toggleSidebar()">
      <div
        [class.symbol-arrow-right]="!visibleSidebar"
        [class.symbol-arrow-left]="visibleSidebar"
        class="toggle-arrow-icon"
      ></div>
    </button>
  </div>

  <div
    class="basin-background-true-black basin-width-100 basin-height-100 basin-position-relative basin-min-width"
  >
    <div
      class="basin-display-flex basin-flex-column canvas-area basin-height-100 basin-width-100"
    >
      <app-debris-flow-map
        [showControls]="(showControls$ | async) || false"
        class="basin-width-100 basin-height-100"
      >
        <div slot="details" class="basin-display-flex basin-flex-row basin-gap-6">
          <div class="width-320px" *ngIf="simulationService.simulationState !== simulationState.Ready">
            <app-simulation-details-overlay></app-simulation-details-overlay>
          </div>
          <div class="width-320px">
            <app-background-simulation-details-overlay></app-background-simulation-details-overlay>
          </div>
        </div>
        <app-welcome-card slot="overlay" *ngIf="(selectedStudyAreaData$ | async) === null" >
        </app-welcome-card>
        <app-overlay-card slot="overlay" *ngIf="(selectedStudyAreaData$ | async) !== null && (statusMessage$ | async)">
          <app-study-area-status-message></app-study-area-status-message>


        </app-overlay-card>
        <canvas #canvas id="canvas" slot="canvas"></canvas>
        <app-paint-info-modal *ngIf="showPaintInfoModal" slot="paintInfo">
        </app-paint-info-modal>
        <app-map-detail-modal *ngIf="showDetails$ | async" slot="info">
        </app-map-detail-modal>
      </app-debris-flow-map>

      <app-predictor-button-bar></app-predictor-button-bar>
    </div>
  </div>
</div>
